/**
 * Content API Service
 * 
 * This module contains API functions for content items
 */

import { ContentItem } from '../types/content';
import { API_CONFIG } from '../config/env';

/**
 * Generic error handler for API requests
 */
const handleApiError = (error: any): never => {
  console.error('API Error:', error);
  throw new Error(error.message || 'An unknown error occurred');
};

/**
 * Fetch content items from the API
 */
export const fetchContentItems = async (): Promise<ContentItem[]> => {
  try {
    // In a real app, this would be a real API call
    // const response = await fetch(`${API_CONFIG.BASE_URL}/api/${API_CONFIG.VERSION}/content`);
    // if (!response.ok) throw new Error('Failed to fetch content');
    // return await response.json();
    
    // For now, return mock data
    await new Promise(resolve => setTimeout(resolve, 500)); // Simulate API delay
    return mockContentItems;
  } catch (error) {
    return handleApiError(error);
  }
};

// Mock content data
export const mockContentItems: ContentItem[] = [
  {
    id: '1',
    title: 'Title of the reel will show here',
    description: 'Welcome to your dream home! This stunning property features a spacious open floor plan, perfect for entertaining guests. Enjoy the modern amenities and luxurious finishes throughout.',
    thumbnailUrl: 'https://images.unsplash.com/photo-1559825481-12a05cc00344?auto=format&fit=crop&w=600&q=80',
    duration: '1:30',
    status: 'live',
    brand: {
      id: 'b1',
      name: 'Kayak',
      logo: '/brand-logos/kayak-orange.svg'
    },
    createdAt: '2025-05-28T10:30:00Z'
  },
  {
    id: '2',
    title: 'Title of the reel will show here',
    description: 'Welcome to your dream home! This stunning property features a spacious open floor plan, perfect for entertaining guests. Enjoy the modern amenities and luxurious finishes throughout.',
    thumbnailUrl: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=600&q=80',
    duration: '1:30',
    status: 'pending',
    brand: {
      id: 'b2',
      name: 'Kayak',
      logo: '/brand-logos/kayak-blue.svg'
    },
    createdAt: '2025-05-27T14:20:00Z'
  },
  {
    id: '3',
    title: 'Title of the reel will show here',
    description: 'Welcome to your dream home! This stunning property features a spacious open floor plan, perfect for entertaining guests. Enjoy the modern amenities and luxurious finishes throughout.',
    thumbnailUrl: 'https://images.unsplash.com/photo-1480714378408-67cf0d13bc1b?auto=format&fit=crop&w=600&q=80',
    duration: '1:30',
    status: 'rejected',
    brand: {
      id: 'b3',
      name: 'Kayak',
      logo: '/brand-logos/kayak-purple.svg'
    },
    createdAt: '2025-05-25T09:15:00Z'
  },
  {
    id: '4',
    title: 'Title of the reel will show here',
    description: 'Welcome to your dream home! This stunning property features a spacious open floor plan, perfect for entertaining guests. Enjoy the modern amenities and luxurious finishes throughout.',
    thumbnailUrl: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=600&q=80',
    duration: '1:30',
    status: 'revise',
    brand: {
      id: 'b4',
      name: 'Kayak',
      logo: '/brand-logos/kayak-green.svg'
    },
    createdAt: '2025-05-23T16:45:00Z'
  },
  {
    id: '5',
    title: 'Title of the reel will show here',
    description: 'Welcome to your dream home! This stunning property features a spacious open floor plan, perfect for entertaining guests. Enjoy the modern amenities and luxurious finishes throughout.',
    thumbnailUrl: 'https://images.unsplash.com/photo-1508385082359-f38ae991e8f2?auto=format&fit=crop&w=600&q=80',
    duration: '1:30',
    status: 'live',
    brand: {
      id: 'b5',
      name: 'Kayak',
      logo: '/brand-logos/kayak-orange.svg'
    },
    createdAt: '2025-05-21T11:30:00Z'
  },
  {
    id: '6',
    title: 'Title of the reel will show here',
    description: 'Welcome to your dream home! This stunning property features a spacious open floor plan, perfect for entertaining guests. Enjoy the modern amenities and luxurious finishes throughout.',
    thumbnailUrl: 'https://images.unsplash.com/photo-1559825481-12a05cc00344?auto=format&fit=crop&w=600&q=80',
    duration: '1:30',
    status: 'live',
    brand: {
      id: 'b6',
      name: 'Kayak',
      logo: '/brand-logos/kayak-blue.svg'
    },
    createdAt: '2025-05-19T08:20:00Z'
  },
  {
    id: '7',
    title: 'Title of the reel will show here',
    description: 'Welcome to your dream home! This stunning property features a spacious open floor plan, perfect for entertaining guests. Enjoy the modern amenities and luxurious finishes throughout.',
    thumbnailUrl: 'https://images.unsplash.com/photo-1559825481-12a05cc00344?auto=format&fit=crop&w=600&q=80',
    duration: '1:30',
    status: 'pending',
    brand: {
      id: 'b7',
      name: 'Kayak',
      logo: '/brand-logos/kayak-pink.svg'
    },
    createdAt: '2025-05-17T15:10:00Z'
  }
];
